/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  UserSessionFacetOption,
  UserSessionFacetOption$inboundSchema,
} from "./usersessionfacetoption.js";

export type ListUserSessionFacetsResult = {
  /**
   * Connecting client facets.
   */
  clients: Array<UserSessionFacetOption>;
  /**
   * Issuer/server facets.
   */
  servers: Array<UserSessionFacetOption>;
  /**
   * Subject (user) facets.
   */
  users: Array<UserSessionFacetOption>;
};

/** @internal */
export const ListUserSessionFacetsResult$inboundSchema: z.ZodMiniType<
  ListUserSessionFacetsResult,
  unknown
> = z.object({
  clients: z.array(UserSessionFacetOption$inboundSchema),
  servers: z.array(UserSessionFacetOption$inboundSchema),
  users: z.array(UserSessionFacetOption$inboundSchema),
});

export function listUserSessionFacetsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListUserSessionFacetsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListUserSessionFacetsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListUserSessionFacetsResult' from JSON`,
  );
}
